import { render, staticRenderFns } from "./gateway-additional-criteria-input.vue?vue&type=template&id=5d56b1dc&"
import script from "./gateway-additional-criteria-input.vue?vue&type=script&lang=js&"
export * from "./gateway-additional-criteria-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports